import { Box, Typography, Divider } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { titleCase } from "../../../utils/helpers";

const ReviewStep = ({ data, errors }) => {
  const hasErrors = errors && Object.keys(errors).length > 0;
  return (
    <Box>
      <div>
        <h3 className="text-xl font-bold text-center mb-6">
          Review Your Job Post
        </h3>
        {hasErrors && (
          <Card sx={{ mb: 3, borderColor: "error.main" }}>
            <CardContent>
              <Typography variant="h6" color="error" gutterBottom>
                Please fix the following errors:
              </Typography>
              <Box sx={{ mt: 1 }}>
                {Object.entries(errors).map(([field, errorMessages]) => (
                  <Box key={field} sx={{ mb: 1 }}>
                    <Typography variant="subtitle2" color="error">
                      {field.charAt(0).toUpperCase() +
                        field.slice(1).replace("_", " ")}
                      :
                    </Typography>
                    {Array.isArray(errorMessages) ? (
                      errorMessages.map((message, index) => (
                        <Typography
                          key={index}
                          variant="body2"
                          color="error"
                          sx={{ ml: 1 }}
                        >
                          • {message}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="error" sx={{ ml: 1 }}>
                        • {errorMessages}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        )}
        <div className="bg-secondary-50 p-6 rounded-lg space-y-4 border">
          <div>
            <h4 className="text-lg font-semibold">{titleCase(data.title)}</h4>
            <p className="text-gray-600">
              {data.location} {data.is_remote && "(Remote)"}
            </p>
            <p className="text-gray-600 capitalize">
              {data.job_type.replace("-", " ")} • {data.experience_level} level
            </p>
          </div>

          <div className="pt-2 border-t">
            <h5 className="font-medium text-sm text-gray-500">Description</h5>
            <p className="text-gray-700 whitespace-pre-line text-sm">
              {data.description}
            </p>
          </div>

          {(data.salary_min || data.salary_max) && (
            <div className="pt-2 border-t">
              <h5 className="font-medium text-sm text-gray-500">
                Salary Range
              </h5>
              <p className="text-gray-700 font-semibold">
                ${data.salary_min || "N/A"} - ${data.salary_max || "N/A"}
              </p>
            </div>
          )}

          <div className="pt-2 border-t">
            <h5 className="font-medium text-sm text-gray-500">Contact Email</h5>
            <p className="text-gray-700">{data.contact_email}</p>
          </div>
          {data.expiry_date && (
            <div className="pt-2 border-t">
              <h5 className="font-medium text-sm text-gray-500">
                Application Deadline
              </h5>
              <p className="text-gray-700">
                {new Date(data.expiry_date).toLocaleDateString()}
              </p>
            </div>
          )}
        </div>
      </div>
    </Box>
  );
};

export default ReviewStep;
